<div *ngIf="visible" class="modal-overlay">
  <div class="modal-content">
    <h2>{{ modalHeading }}</h2>
    <p>{{ modalDescription }}</p>

    <!-- Loading State -->
    <div *ngIf="isLoading && !errorMessage" class="loading-state">
      <div class="spinner"></div>
      <p>Loading subscription plans...</p>
    </div>

    <!-- Plan Selection -->
    <div *ngIf="!isLoading" class="plan-options">
      <div *ngFor="let plan of plans; let i = index"
           [class.selected]="selectedPlan?.id === plan.id"
           [class.recommended]="i === 1"
           (click)="onPlanSelect(plan)"
           class="plan-option">
        <div class="plan-header">
          <h2>{{ plan.name }}</h2>
          <div *ngIf="i === 1" class="recommended-badge">Recommended</div>
        </div>
        <div class="price-container">
          <span class="currency">{{ plan.currency || '₦' }}</span>
          <span class="price">{{ plan.amount / 100 | number:'1.0-0' }}</span>
          <span class="interval">/{{ plan.interval || 'mo' }}</span>
        </div>
        <div *ngIf="plan.productDescription || plan.description" class="description">
          {{ plan.productDescription || plan.description }}
        </div>
        <!-- <div *ngIf="plan.features" class="features">
          <div *ngFor="let feature of plan.features" class="feature">
            ✓ {{ feature }}
          </div>
        </div> -->
      </div>
    </div>

    <!-- Upgrade Warning -->
    <div *ngIf="showUpgradeWarning" class="upgrade-warning">
      <div class="upgrade-warning-content">
        <h3>Account Upgrade</h3>
        <p>You are about to upgrade from <strong>Calculator Only</strong> to a <strong>Full</strong> account. This will unlock all features including Inventory Management, Manufacturing, Reports, and more.</p>
        <p>This change will take effect after payment is completed.</p>
        <div class="upgrade-warning-actions">
          <button class="btn-confirm" (click)="confirmUpgrade()">Continue with Upgrade</button>
          <button class="btn-cancel" (click)="cancelUpgrade()">Cancel</button>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>

    <!-- Action Buttons -->
    <div class="modal-actions">
      <button
        (click)="handlePayment()"
        [disabled]="isLoading || !selectedPlan"
        class="paystack-button"
      >
        {{ isLoading ? 'Processing...' : (isPlanExpired ? 'Activate New Plan' : 'Subscribe with Paystack') }}
      </button>

      <!-- <button

        (click)="generateUpdateLink()"
        [disabled]="isLoading"
        class="update-payment-button"
      >
        {{ isLoading ? 'Loading...' : 'Update Payment Method' }}
      </button> -->

      <button
        (click)="logout()"
        [disabled]="isLoading"
        class="logout-button"
      >
        Back to Login
      </button>
    </div>

    <!-- Paystack Inline Script will be loaded here -->
    <script src="https://js.paystack.co/v1/inline.js"></script>
  </div>
</div>
